module.exports = __webpack_public_path__ + "static/media/map_marker_alarm_icon.c0769feb.svg";